import React from "react";
import { useTranslation } from "react-i18next";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import TableContent from "./TableContent/TableContent";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_Guests_components_MainSection";

const MainSection: React.FC = () => {
  const { t } = useTranslation(LOCALE);

  const tabs = [
    { label: t("mainSection.tabs.giftList"), component: <TableContent /> },
  ];

  return (
    <main className="p-4 md:pb-0 pb-24">
      <TabNavigation tabs={tabs} />
    </main>
  );
};

export default withTranslations(LOCALE)(MainSection);
